export default __webpack_public_path__ + "static/media/gallery_00.2dc02f32.jpg";